
import React, { useState } from 'react';
import { _postURL } from '@/api/index';
import { useRouter } from "next/router";
import Link from 'next/link';

export default function Index({ session, t }) {
    const { asPath, locale } = useRouter();
    const router = useRouter();

    const _handleDownloadClick = () => {
        const userAgent =
          typeof window !== "undefined"
            ? navigator.userAgent || navigator.vendor || window.opera
            : "";
      
        const isAppleDevice = /Mac|iPhone|iPad|iPod/i.test(userAgent);
      
        if (isAppleDevice) {
          window.open(
            "https://apps.apple.com/my/app/keyauto-malaysia-wek4u/id6670432545",
            "_blank"
          );
        } else {
          window.open(
            "https://play.google.com/store/apps/details?id=my.keyauto.WeK4U",
            "_blank"
          );
        }
    };
    
    return (
    <>
        <div className="header2">
            <div className='header2-wrapper'>
                <Link href={'/'}>
                    <div className='header-logo mt_4 d_flex cursorPointer'>
                        <img className='w-100' src="/assets/images/logo.png" />
                    </div>
                </Link>
                <button className="download" onClick={_handleDownloadClick}>{t("download_app")}</button>
            </div>
        </div>
       
    </>
    )
    ;
}
